import React from 'react';


export default function useServerMessages(conversation, limit = 50) {
  const [ serverMessages, setServerMessages ] = React.useState([]);

  React.useEffect(() => {
    async function getMessages() {
      // TODO: add pagination with infinite scrolling?
      const messages  = await conversation.getMessages(limit);
      const { items } = messages;
      setServerMessages(items);
    }

    if (conversation)
      getMessages();
  }, [ conversation, limit ]);

  return serverMessages;
}
